import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../utils/leads";

export const AnalyticsManager = () => {
  const { pathname, search } = useLocation();
  const firstRoute = useRef(true);

  useEffect(() => {
    if (firstRoute.current) {
      firstRoute.current = false;
      return;
    }

    trackEvent("page_view", {
      page_path: `${pathname}${search}`,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
};
